export const COMPONENT_LOADING_TIMEOUT_MS = 60_000;
export const COMPONENT_SLOW_LOG_TIMEOUT_MS = COMPONENT_LOADING_TIMEOUT_MS / 2;
export const ACTION_COMPONENT_LOAD_START = 'ComponentLoadStart';
export const ACTION_COMPONENT_LOAD_END = 'ComponentLoadEnd';
export const ACTION_COMPONENT_LOG = 'ComponentLog';
